var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{staticClass:"but",attrs:{"size":"mini","type":"success"},on:{"click":_vm.exportExcel}},[_vm._v(_vm._s(_vm.$t("lang.xlsx.export")))])}
var staticRenderFns = []

export { render, staticRenderFns }